import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { ErrorBoundary } from "./ErrorBoundary";
import App from "./App.tsx";
import { SITE_TITLE } from "./content";
import { applySeo } from "./seo";

document.documentElement.classList.add("is-live");
document.querySelector(".seo-foot")?.remove();
applySeo();
document.title = SITE_TITLE;

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
